<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已审核</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">组装拆卸单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
			    <Col span="8">单据编号：{{documentItem.code}}</Col>
			    <Col span="8">业务日期：{{documentItem.businessDate}}</Col>
			    <Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
			    <Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					拆卸商品
				</div>
			</div>
			<Table :columns="splitListColumn" :data="documentItem.splitDetailList"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					组装商品
				</div>
			</div>
			<Table :columns="assemblyListColumn" :data="documentItem.assemblyDetailList"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
		<div class="list-module" style="display: flex;justify-content: flex-end;">
			<button class="jxyd-button jxyd-primary" title="打印单据" @click="printDocument()">
				<Icon type="md-print" size='18' />
				打印
			</button>
			<button class="jxyd-button jxyd-primary" title="复制单据" @click="copyDocument(documentItem)">
				<Icon type="md-print" size='18' />
				复制
			</button>
		</div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import formatNum from '@/utils/formatNum'
	import printMixin from '@/mixins/printMixin' // 引入打印 mixin
	export default {
		name: 'salessplitlistdetail',
		mixins: [printMixin],
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					splitDetailList: [],
					assemblyDetailList: [],
					userId: '',
					userName: '',
					creator: 0,
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				splitListColumn: [
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 220,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 220,
					},
					{
						title: '单位',
						key: 'unit',
						width: 130
					},
					{
						title: '批次号',
						key: 'batchCode',
						width: 270,
						render: (h, params) => {
							return h('span', {}, params.row.batchCode.join(','))
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock('splitDetailList', params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130,
					},
					{
						title: '零售价',
						key: 'price',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentRetailPrice(params.row) + '元');
						}
					}
				],
				assemblyListColumn: [
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 220,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 220,
					},
					{
						title: '单位',
						key: 'unit',
						width: 130
					},
					{
						title: '仓库',
						key: 'depotName',
						width: 130,
					},
					{
						title: '保质期',
						key: 'sellbyDate',
						width: 200,
						render: (h, params) => {
							if(!params.row.sellByDate || params.row.sellByDate.length!= 2){
								return h('span',{},'');
							}
							return h('span', {}, params.row.sellByDate.join('~').replace(/ 00:00:00/g, ''))
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock('assemblyDetailList', params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130
					},
					{
						title: '零售价',
						key: 'price',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentRetailPrice(params.row) + '元');
						}
					}
				]
			}
		},

		methods: {
			getUnitData(item, unit) {
				if (item.commodity.extraUnits) {
					let unitData = item.commodity.extraUnits.find(m => m.unit == unit);
					if (unitData) {
						return unitData;
					}
				}
				return null;
			},
			getCurrentRetailPrice(data) {
				let items = data.format.split(',');
				if (items.length <= 0) {
					return 0;
				}
				let priceTypeGroup = data.commodity
					.commodityPriceTypeGroups.find(m => m.groupName == items[0]);
				if (!priceTypeGroup || priceTypeGroup.commodityPriceTypes.length <= 0) {
					return 0;
				}
				let priceType = priceTypeGroup.commodityPriceTypes.find(m => m.priceType == items[1]);
				if (!priceType) {
					return 0;
				}
				let unitData = this.getUnitData(data, data.unit);
				if (!unitData) {
					return 0;
				}
				return formatNum(priceType.retailPrice / unitData.conversionRate);
			},
			getCurrentIStock(tag, index) {
				let commodityInventorys = this.documentItem[tag][index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem[tag][index].format) {
						stock += commodityInventorys[i].stock;
					}
				}

				let extraUnits = this.getUnitData(this.documentItem[tag][index], this.documentItem[tag][index].unit);
				if (extraUnits) {
					stock = extraUnits.conversionRate * stock;
				}
				return formatNum(stock);
			},
			getSplitList(splitListId) {
				let self = this;
				request.get('/api/SplitList/GetSplitList', {
					params: {
						id: splitListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
			getSplitListByCode(splitListCode) {
				let self = this;
				request.get('/api/SplitList/GetSplitListByCode', {
					params: {
						code: splitListCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
			formatNum(value) {
				// 调用导入的 formatNum 函数
				return formatNum(value);
			},
			async copyDocument(param) {
				let self = this;
				await this.$Modal.confirm({
					title: "操作警告",
					content: "是否复制单据？",
					async onOk() {
						let result = await request.get('api/SplitList/GetNextCode', {
							params: {
								prefix: 'ZCD'
							}
						});
						if (!result || result.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '获取编号失败'
							});
							return;
						}
						let data = JSON.parse(JSON.stringify(param));
						data.id = 0;
						data.code = result.data;
						data.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
						data.createDate = data.businessDate;
						data.userId = parseInt(localStorage.getItem("userId"));
						data.userName = localStorage.getItem("userName");
						data.creator = parseInt(localStorage.getItem("userId"));
						data.checkState = 1;
						self.dataSubmitAndCheck(data);
					},
					onCancel() {}
				});
			},
			printDocument() {
				const printData = this.formatPrintData([this.documentItem])
				// 使用 mixin 提供的打印方法
				this.printWithTemplate(printData, 'splitList')
			},
			formatPrintData(rawData) {
				// rawData 已经是数组
				if (!Array.isArray(rawData)) {
					console.error('formatPrintData: rawData 不是数组', rawData);
					return [];
				}

				// 辅助函数：添加序号
				const addSerialNo = (arr) => arr.map((item, idx) => ({
					...item,
					serialNo: idx + 1
				}));

				// 辅助函数：安全获取数值
				const safeNumber = (value) => {
					const num = Number(value);
					return isNaN(num) ? 0 : num;
				};

				// 辅助函数：计算合计
				const calcTotals = (arr, fields) => {
					if (!Array.isArray(arr) || arr.length === 0) {
						const emptyTotals = {};
						fields.forEach(f => {
							emptyTotals[f] = 0;
						});
						return emptyTotals;
					}

					const totals = {};
					fields.forEach(f => {
						totals[f] = 0;
					});

					arr.forEach(item => {
						fields.forEach(f => {
							totals[f] += safeNumber(item[f]);
						});
					});

					return totals;
				};

				// 格式化日期
				const formatDate = (dateStr) => {
					if (!dateStr) return '';
					if (dateStr instanceof Date) {
						const year = dateStr.getFullYear();
						const month = String(dateStr.getMonth() + 1).padStart(2, '0');
						const day = String(dateStr.getDate()).padStart(2, '0');
						return `${year}-${month}-${day}`;
					}
					if (typeof dateStr === 'string') {
						return dateStr.split(' ')[0];
					}
					return '';
				};

				// 获取商品单价（从商品信息中获取）
				const getCommodityPrice = (item) => {
					if (item.commodity && item.commodity.retailPrice) {
						return safeNumber(item.commodity.retailPrice);
					}
					return 0;
				};

				// 格式化单条组装拆卸单记录
				const formatSingle = (record) => {
					if (!record) return {};

					// 1. 格式化拆卸商品明细（出库）
					let splitDetailRaw = (record.splitDetailList || []).map(item => ({
						name: item.name || '',
						format: item.format || '',
						unit: item.unit || '',
						quantity: safeNumber(item.quantity),
						price: getCommodityPrice(item),
						depotName: item.depotName || '',
						batchCode: item.batchCode || '',
						note: item.note || ''
					}));

					// 添加序号
					let splitDetail = addSerialNo(splitDetailRaw);

					// 添加合计行
					if (splitDetailRaw.length > 0) {
						const totals = calcTotals(splitDetailRaw, ['quantity']);
						const totalAmount = splitDetailRaw.reduce((sum, item) => sum + (item.quantity * item.price),
							0);
						splitDetail.push({
							serialNo: '',
							name: '',
							format: '',
							unit: '合计',
							quantity: totals.quantity,
							price: '',
							depotName: '',
							batchCode: '',
							note: '',
							totalAmount: totalAmount,
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}

					// 2. 格式化组装商品明细（入库）
					let assemblyDetailRaw = (record.assemblyDetailList || []).map(item => ({
						name: item.name || '',
						format: item.format || '',
						unit: item.unit || '',
						quantity: safeNumber(item.quantity),
						price: getCommodityPrice(item),
						depotName: item.depotName || '',
						batchCode: item.batchCode || '',
						note: item.note || ''
					}));

					// 添加序号
					let assemblyDetail = addSerialNo(assemblyDetailRaw);

					// 添加合计行
					if (assemblyDetailRaw.length > 0) {
						const totals = calcTotals(assemblyDetailRaw, ['quantity']);
						const totalAmount = assemblyDetailRaw.reduce((sum, item) => sum + (item.quantity * item.price),
							0);
						assemblyDetail.push({
							serialNo: '',
							name: '',
							format: '',
							unit: '合计',
							quantity: totals.quantity,
							price: '',
							depotName: '',
							batchCode: '',
							note: '',
							totalAmount: totalAmount,
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}

					// 返回格式化后的数据
					return {
						code: record.code || '',
						userName: record.userName || '',
						businessDate: formatDate(record.businessDate),
						note: record.note || '',
						// 拆卸商品（出库）
						splitDetail: splitDetail,
						// 组装商品（入库）
						assemblyDetail: assemblyDetail
					};
				};

				// 直接返回格式化后的数组
				return rawData.map(record => formatSingle(record));
			},
			dataSubmitAndCheck(data) {
				let self = this
				request.post('api/SplitList/EditSplitList', data).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败'
						});
						return
					}
					//记录组装拆卸单操作
					let log = {
						FlowId: result.data,
						Title: '组装拆卸单日志',
						OperationContent: '创建了此组装拆卸单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败'
							});
							return;
						}
					}).catch(err => {})
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '复制成功'
					});
				}).catch(err => {})
			},
		},
		watch: {
			'$route.query.splitListId':{
				immediate: true,
				handler(param) {
					if(param){
						this.getSplitList(param);
					}
				}
			},
			'$route.query.splitListCode':{
				immediate: true,
				handler(param) {
					if(param){
						this.getSplitListByCode(param);
					}
				}
			}
		},
		created: function() {
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}
	
	.list-base{
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}
	
	.list-base-left{
		float: left;
		display: flex;
		color: #000;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 100%;           /* 父元素需要固定高度或其他百分比高度 */
	}
	
	.list-base-left-span{
		font-size: 18px;
	}
	
	.list-base-right{
		display: flex;
		float: right;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 36px;     
	}
	
	.list-base-right-span{
		margin-left: 10px;
	}
	
	.span-back-color{
		color: #000;
	}
	
	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}
	
	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}
	
	.list-module{
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}
	
	.div-content-row div{
		padding: 15px;
	}
	
	.div-content-row-center div{
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}
	
	.amount-color{
		color: rgb(255, 106, 127);
	}
	
	.div-content-detail{
		margin: 15px;
		background-color:#f8f8f9;
		padding: 20px;
	}
	
	.div-content-detail-title{
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}
	.div-content-detail-list{
		margin-top: 10px;
	}
	.div-content-detail-list-title{
		text-indent: 0.5em;
	}
	
	.div-content-detail-list-content{
		overflow: hidden;
	}
	
	.div-content-detail-list-content-item{
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}
</style>